import { useEffect, useState } from 'react';

/**
 * State returned from this hook can be used to disturb Next.js caching.
 * @returns boolean
 ** Related doc: https://nextjs.org/docs/messages/react-hydration-error#solution-1-using-useeffect-to-run-on-the-client-only
 * */
export const useClientOnly = () => {
    const [clientOnly, setClientOnly] = useState(false);

    useEffect(() => {
        setClientOnly(true);
    }, []);

    return clientOnly;
};
